import { render, staticRenderFns } from "./TarefasAprovacaoAlmoxarifadoModal.vue?vue&type=template&id=639d84a2"
import script from "./TarefasAprovacaoAlmoxarifadoModal.vue?vue&type=script&lang=js"
export * from "./TarefasAprovacaoAlmoxarifadoModal.vue?vue&type=script&lang=js"
import style0 from "./TarefasAprovacaoAlmoxarifadoModal.vue?vue&type=style&index=0&id=639d84a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports